import { Dropdown } from 'rsuite';
import { cssVars } from '@/app/styles';
import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 38px 32px 21px;
  width: 100%;
`;

export const StyledBalloon = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
`;

export const ToggleWrapper = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  margin-top: 34px;
  .rs-btn-toggle {
    background-color: rgba(16, 25, 56, 0.7);
  }

  .rs-btn-toggle-checked:hover {
    background-color: #2589f5;
  }

  .rs-btn-toggle-checked {
    background-color: #2589f5;
  }
`;

export const FlexRowSpaceBetween = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const TopWrapper = styled(FlexRowSpaceBetween)`
  margin-top: 32px;
`;

export const BottomWrapper = styled(FlexRowSpaceBetween)`
  /* margin-bottom: 30px; */
`;

export const IconButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export const IconButtonParentWrapper = styled(IconButtonWrapper)`
  margin-top: 24px;
`;

export const StyledButtonTitle = styled.div`
  font-family: Nunito Sans;
  font-size: 14px;
  font-weight: normal;
  margin-right: 10px;
  color: ${(props) =>
    props.isActive ? cssVars.color.rentalscapeBlue : '#101938'};
  ::before {
    content: '${(props) => props.title}';
  }
`;

export const IconWrapper = styled.div`
  margin-right: 5px;
  margin-top: 2px;
  color: ${(props) =>
    props.isActive ? cssVars.color.rentalscapeBlue : '#101938'};
`;

export const StyledDropdownItem = styled(Dropdown.Item)`
  background-color: ${(props) => (props.active ? '#f2faff' : 'initial')};
`;

export const ActiveLine = styled.div`
  width: 0px;
  transition: all 0.2s ease-in;
  position: ${(props) => (props.enterFromLeft ? 'unset' : 'absolute')};
  top: ${(props) => (props.enterFromLeft ? 'unset' : 0)};
  right: ${(props) => (props.enterFromLeft ? 'unset' : 0)};
  border-bottom: 2px solid #2098d1;
`;
